import { instance, next } from "./base";

export const getSettings = async () => {
  const { data } = await instance()
    .get("/api/v1/admin/settings")
    .catch((e) => next(e));

  return data?.data;
};

export const updateSettings = async (values) => {
  const { data } = await instance()
    .patch("/api/v1/admin/settings", values)
    .catch((e) => next(e));

  return data?.data;
};

export const changePassword = async (values) => {
  const { data } = await instance()
    .patch("/api/v1/admin/settings/change-password", values)
    .catch((e) => next(e));

  return data?.data;
};

export const createBanner = async (values) => {
  const { data } = await instance()
    .post("/api/v1/admin/banners", values)
    .catch((e) => next(e));

  return data?.data;
};

export const updateBanner = async (values) => {
  const id = values.id;
  delete values.id;
  const { data } = await instance()
    .patch(`/api/v1/admin/banners/${id}`, values)
    .catch((e) => next(e));

  return data?.data;
};

export const deleteBanner = async (values) => {
  const id = values.id;
  delete values.id;
  const { data } = await instance()
    .delete(`/api/v1/admin/banners/${id}`)
    .catch((e) => next(e));

  return data?.data;
};

export const fetchBanner = async (section) => {
  const { data } = await instance()
    .get("/api/v1/admin/banners", { params: { section } })
    .catch((e) => next(e));

  return data?.data;
};

export const createNotification = async (values) => {
  const { data } = await instance()
    .post("/api/v1/admin/notifications", values)
    .catch((e) => next(e));

  return data?.data;
};

export const fetchNotification = async () => {
  const { data } = await instance()
    .get("/api/v1/admin/notifications", { params: { limit: 20 } })
    .catch((e) => next(e));

  return data?.data;
};

export const fetchRoles = async () => {
  const { data } = await instance()
    .get("/api/v1/admin/roles", { params: { limit: 20 } })
    .catch((e) => next(e));

  return data?.data;
};

export const createRole = async (values) => {
  const { data } = await instance()
    .post("/api/v1/admin/roles", values)
    .catch((e) => next(e));

  return data?.data;
};

export const editRole = async (values) => {
  const id = values.id;
  delete values.id;

  const { data } = await instance()
    .patch(`/api/v1/admin/roles/${id}`, values)
    .catch((e) => next(e));

  return data?.data;
};

export const fetchPermissions = async () => {
  const { data } = await instance()
    .get("/api/v1/admin/roles/permissions")
    .catch((e) => next(e));

  return data?.data;
};
export const deleteRole = async (id) => {
  const { data } = await instance()
    .delete(`/api/v1/admin/roles/${id}`)
    .catch((e) => next(e));

  return data?.data;
};
